<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">配置val</h1>
    <el-row :gutter="20" class="user-options">
      <el-select style="width: 160px" class="header-item" v-model="valid" placeholder="">
        <el-option v-for="(item, itemIndex) in valids" :key="itemIndex" :label="item.label"
          :value="item.value"></el-option>
      </el-select>

      <el-button v-if="row != ''" type="warning" @click="getDayChatDetai" :loading="login1">
        查询
      </el-button>
      <el-button v-if="row != ''" type="success" @click="cre"> 创建 </el-button>
    </el-row>
    <!-- 创建弹窗 -->
    <el-drawer title="" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
      <div class="add">
        <el-row class="ruid">
          <div class="ruids">
            <div>
              <span>键值:</span>
              <el-input :disabled="true" v-model="configKey" style="width: 160px" placeholder="请输入内容"></el-input>
            </div>
            <div v-if="row.countryCode == 1">
              <span>国家:</span>
              <el-select v-if="!msg" filterable multiple style="width: 240px" v-model="country" placeholder>
                <el-option v-for="(item, itemIndex) in countryList" v-bind:key="itemIndex + 99"
                  :label="item.country_name" :value="item.countryCode">
                  <span style="float: left">{{ item.country_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.countryCode
                  }}</span>
                </el-option>
              </el-select>
              <el-select v-if="msg" filterable style="width: 240px" v-model="country" placeholder>
                <el-option v-for="(item, itemIndex) in countryList" v-bind:key="itemIndex + 99"
                  :label="item.country_name" :value="item.countryCode">
                  <span style="float: left">{{ item.country_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.countryCode
                  }}</span>
                </el-option>
              </el-select>
            </div>
            <div v-if="row.gender == 1">
              <span>身份:</span>
              <el-select filterable style="width: 240px" v-model="gender" placeholder>
                <el-option v-for="(item, itemIndex) in genderList" v-bind:key="itemIndex + 99" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div v-if="row.majia == 1">
              <span>马甲:</span>
              <el-select style="width: 100px" v-model="majia" placeholder>
                <el-option v-for="(item, itemIndex) in valids_" v-bind:key="itemIndex + 99" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div v-if="row.agentId == 1" class="ruids">
            <div>
              <span>代理id:</span>
              <el-input v-model="agentId" style="width: 160px" placeholder="请输入"></el-input>
            </div>
          </div>
          <div class="ruids">
            <div v-if="row.channel == 1">
              <span>渠道:</span>
              <el-select v-if="!msg" filterable multiple style="width: 200px" v-model="channel" placeholder>
                <el-option v-for="(item, itemIndex) in channelsList" v-bind:key="itemIndex + 199" :label="item.name"
                  :value="item.value"></el-option>
              </el-select>
              <el-select v-if="msg" style="width: 200px" v-model="channel" filterable placeholder>
                <el-option v-for="(item, itemIndex) in channelsList" v-bind:key="itemIndex" :label="item.name"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div v-if="row.langId == 1">
              <span>语言:</span>
              <el-select v-if="!msg" filterable multiple style="width: 240px" v-model="language" placeholder>
                <el-option v-for="(item, itemIndex) in languageList" v-bind:key="itemIndex + 199" :label="item.language"
                  :value="item.langCode"></el-option>
              </el-select>
              <el-select v-if="msg" style="width: 240px" v-model="language" filterable placeholder>
                <el-option v-for="(item, itemIndex) in languageList" v-bind:key="itemIndex + 199" :label="item.language"
                  :value="item.langCode"></el-option>
              </el-select>
            </div>
          </div>
          <div class="ruids">
            <div v-if="row.platform == 1">
              <span>平台:</span>
              <el-select style="width: 100px" v-model="platform" placeholder>
                <el-option v-for="(item, itemIndex) in platforms" v-bind:key="itemIndex + 99" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div v-if="row.ver == 1">
              <span>版本:</span>
              <el-input style="width: 100px" v-model="ver" type="number" placeholder="请输入"></el-input>
            </div>
          </div>
          <div class="ruids">
            <div v-if="row.thanVer == 1">
              <span>大于等于版本:</span>
              <el-input style="width: 100px" v-model="thanVer" type="number" placeholder="请输入"></el-input>
            </div>
            <div v-if="row.lessVer == 1">
              <span>小于等于版本:</span>
              <el-input style="width: 100px" v-model="lessVer" type="number" placeholder="请输入"></el-input>
            </div>
          </div>
          <div class="ruids">
            <div v-if="row.isNew == 1">
              <span>是否新用户:</span>
              <el-select style="width: 100px" v-model="isNew" placeholder>
                <el-option v-for="(item, itemIndex) in isNews" v-bind:key="itemIndex + 99" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div v-if="row.isPay == 1">
              <span>是否付费用户:</span>
              <el-select style="width: 100px" v-model="isPay" placeholder>
                <el-option v-for="(item, itemIndex) in isPays" v-bind:key="itemIndex + 99" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="ruids">
            <div v-if="row.hostLevel == 1">
              <span>主播等级:</span>
              <el-select style="width: 100px" v-model="hostLevel" placeholder>
                <el-option v-for="(item, itemIndex) in hostLevels" v-bind:key="itemIndex + 99" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div v-if="row.bossLevel == 1">
              <span>用户boos等级:</span>
              <el-select style="width: 100px" v-model="bossLevel" placeholder>
                <el-option v-for="(item, itemIndex) in bossLevels" v-bind:key="itemIndex + 99" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="ruids">
            <div>
              <span>是否可用:</span>
              <el-select style="width: 100px" v-model="valid_" placeholder>
                <el-option v-for="(item, itemIndex) in valids_" v-bind:key="itemIndex + 99" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>

          <div>
            <div class="text">
              <span>值:</span>
              <JsonEditorVue v-model="defaultVal" :stringified="true" mode="text" :navigationBar="false" :onRenderMenu="(items, context) => {
                return items.filter(
                  (v) =>
                    !['table', 'tree'].includes(v.text) &&
                    v.type === 'button'
                )
              }
                " />
              <!-- <el-input
                style="width: 260px"
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="defaultVal"
              >
              </el-input> -->
            </div>
          </div>
          <el-row  type="flex" justify="center"> <el-button type="primary" v-if="row.configKey == 'remote_beauty_config'"
              @click="handleView">查看</el-button></el-row>
        </el-row>

        <el-row class="buttom">
          <el-button type="primary" v-if="!msg" @click="establish()">创建</el-button>
          <el-button type="primary" v-if="msg" @click="establish(1)">修改</el-button>
        </el-row>
      </div>
    </el-drawer>
    <!-- 表格 -->
    <el-row class="user-options">
      <el-table :data="dayChatDetailData" style="width: 100%" v-loading="login1" border>
        <el-table-column prop="configKey" label="键" align="center">
        </el-table-column>
        <el-table-column prop="configValue" label="值" align="center">
        </el-table-column>
        <el-table-column v-if="row.platform == 1" prop="platform" label="平台" align="center">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.platform == 2
                  ? 'ios'
                  : scope.row.platform == 0
                    ? '默认'
                    : 'Android'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.channel == 1" prop="channel" label="渠道" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.channel }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.countryCode == 1" prop="countryCode" label="国家码" align="center" sortable>
          <template slot-scope="scope">
            <div>
              {{ scope.row.countryCode }}-{{
                countryList.find(
                  (item) => item.countryCode == scope.row.countryCode
                )
                  ? countryList.find(
                    (item) => item.countryCode == scope.row.countryCode
                  ).country_name
                  : '全部'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.gender == 1" prop="countryCode" label="身份" align="center" sortable>
          <template slot-scope="scope">
            <div>
              {{
                scope.row.gender === 1
                  ? '用户'
                  : scope.row.gender === 2
                    ? '主播'
                    : 'all'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.langId == 1" prop="langId" label="语言码" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.langId }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.isNew == 1" prop="isNew" label="是否新用户" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.isNew == 0 ? '否' : '是' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.isPay == 1" prop="isPay" label="是否付费用户" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.isPay == 0 ? '否' : '是' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.majia == 1" prop="majia" label="马甲包" align="center">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.majia == 0
                  ? '非马甲包'
                  : scope.row.majia == 1
                    ? '仅马甲包'
                    : 'all'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.ver == 1" prop="ver" label="=版本号" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.ver }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.thanVer == 1" prop="thanVer" label=">=版本号" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.thanVer }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.lessVer == 1" prop="lessVer" label="<=版本号" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.lessVer }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="row.agentId == 1" prop="agentId" label="代理id" align="center">
          <template slot-scope="scope">
            {{ scope.row.agentId }}
          </template>
        </el-table-column>
        <el-table-column v-if="row.bossLevel == 1" prop="bossLevel" label="用户boss等级" align="center">
          <template slot-scope="scope">
            {{ 'V' + scope.row.bossLevel }}
          </template>
        </el-table-column>
        <el-table-column prop="hostLevel" v-if="row.hostLevel == 1" label="主播等级" align="center">
          <template slot-scope="scope">
            {{ 'L' + scope.row.hostLevel }}
          </template>
        </el-table-column>
        <el-table-column prop="valid" label="状态" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.valid == 0 ? '无效' : '有效' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="ctime" label="创建时间" align="center">
          <template slot-scope="scope">
            {{ format_(scope.row.ctime) }}
          </template>
        </el-table-column>
        <el-table-column prop="mtime" label="修改时间" align="center">
          <template slot-scope="scope">
            {{ format_(scope.row.mtime) }}
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>

        <el-table-column label="操作" align="center" width="130">
          <template slot-scope="scope">
            <el-button type="primary" @click="modify(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 弹窗 -->
    <el-dialog title="修改" :visible.sync="dialogVisible" width="50%">
      <FormatterJson :jsonData="tempVal" @submit="handleSubmit" @cancel="dialogVisible = false" />
    </el-dialog>
  </el-card>
</template>

<script>
import JsonEditorVue from 'json-editor-vue'
import FormatterJson from '@/components/FormatterJson.vue'
import { log } from 'video.js'
export default {
  components: { JsonEditorVue, FormatterJson },
  data() {
    return {
      defaultVal: '',
      tempVal: '',
      dialogVisible: false,
      row: '',
      id: '',
      msg: false,
      channel: 'all',
      channelsList: [],
      country: 'all',
      countryList: [],
      gender: 0,
      majia: 0,
      genderList: [
        {
          name: '用户',
          value: 1,
        },
        {
          name: '主播',
          value: 2,
        },
      ],
      drawer: false,
      direction: 'rtl',
      // 加载
      login1: false,
      valid: 1,
      valids: [
        {
          label: 'total',
          value: -1,
        },
        {
          label: '可用',
          value: 1,
        },
        {
          label: '不可用',
          value: 0,
        },
      ],
      bossLevel: 0,
      bossLevels: [
        {
          label: 'null',
          value: -1,
        },
        {
          label: 'v0',
          value: 0,
        },
        {
          label: 'v1',
          value: 1,
        },
        {
          label: 'v2',
          value: 2,
        },
        {
          label: 'v3',
          value: 3,
        },
        {
          label: 'v4',
          value: 4,
        },
        {
          label: 'v5',
          value: 5,
        },
        {
          label: 'v6',
          value: 6,
        },
        {
          label: 'v7',
          value: 7,
        },
        {
          label: 'v8',
          value: 8,
        },
      ],
      agentId: '',
      hostLevel: 0,
      hostLevels: [
        {
          label: 'null',
          value: -1,
        },
        {
          label: 'Level0',
          value: 0,
        },
        {
          label: 'Level1',
          value: 1,
        },
        {
          label: 'Level2',
          value: 2,
        },
        {
          label: 'Level3',
          value: 3,
        },
      ],
      platform: 0,
      platforms: [
        {
          label: '默认',
          value: 0,
        },
        {
          label: 'Android',
          value: 1,
        },
        {
          label: 'IOS',
          value: 2,
        },
      ],
      ver: 0,
      thanVer: 0,
      lessVer: 0,
      isNew: 0,
      isNews: [
        {
          label: '不是',
          value: 0,
        },
        {
          label: '是',
          value: 1,
        },
      ],
      isPay: 0,
      isPays: [
        {
          label: '不是',
          value: 0,
        },
        {
          label: '是',
          value: 1,
        },
      ],
      valid_: 1,
      valids_: [
        {
          label: '无效',
          value: 0,
        },
        {
          label: '有效',
          value: 1,
        },
      ],
      operator: this.$store.getters.username,
      language: 'total',
      languageList: '',
      configKey: '',
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],
    }
  },
  created() {
    this._getCountry()
    this.languages()
    this.channelListss()
  },
  methods: {
    async channelListss() {
      const { data: res } = await this.$axios(
        this.$store.getters.path.newChannelList +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      )

      if (res.code == 0) {
        this.channelsList = res.data
      }
    },
    async languages() {
      const { data: res } = await this.$axios(
        this.$store.getters.path.langList +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      )
      if (res !== null) {
        this.languageList = [{ language: 'all', langCode: 'all' }, ...res.data]
      }
    },

    async _getCountry() {
      const { data: res } = await this.$axios(
        this.$store.getters.path.CountryList +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      )
      if (res !== null) {
        this.countryList = res.data.countryList
      }
    },
    status_(data) {
      let a = {
        0: '不可用',
        1: '客户端可用',
        2: '后台可用',
        3: '双端可用',
      }
      return a[data]
    },
    format_(data) {
      let date = new Date(data * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h = date.getHours() + ':'
      let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true
      let data = {
        configKey: this.row.configKey,
        valid: this.valid,
      }
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_val_list +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        data
      )
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data
      this.total = res.data.total
    },
    // 创建/修改
    async establish(num) {
      if (this.defaultVal == '' || this.defaultVal == undefined) {
        return this.$message.error('值，不能为空')
      }
      let a = this.defaultVal
      if (typeof a === 'object') {
        try {
          a = JSON.stringify(a)
        } catch (err) {
          this.$message.error('值格式不正确，请检查')
          return
        }
      }
      let url =
        this.$store.getters.path.config_val_batch_create +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        channel: this.channel.toString(','),
        countryCode: this.country.toString(','),
        configKey: this.configKey,
        platform: this.platform,
        langId: this.language.toString(','),
        isPay: this.isPay,
        isNew: this.isNew,
        ver: this.ver,
        thanVer: this.thanVer,
        lessVer: this.lessVer,
        valid: this.valid_,
        agentId: this.agentId,
        gender: this.gender,
        majia: this.majia,
        hostLevel: this.hostLevel,
        bossLevel: this.bossLevel,
        operator: this.operator,
        configValue: a,
      }
      if (num == 1) {
        url =
          this.$store.getters.path.config_val_update +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        data = {
          id: this.id,
          channel: this.channel.toString(','),
          countryCode: this.country.toString(','),
          configKey: this.configKey,
          platform: this.platform,
          langId: this.language.toString(','),
          isPay: this.isPay,
          isNew: this.isNew,
          ver: this.ver,
          valid: this.valid_,
          thanVer: this.thanVer,
          lessVer: this.lessVer,
          agentId: this.agentId,
          gender: this.gender,
          majia: this.majia,
          hostLevel: this.hostLevel,
          bossLevel: this.bossLevel,
          operator: this.operator,
          configValue: a,
        }
      }

      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.drawer = false
      this.getDayChatDetai()
    },
    cre() {
      this.drawer = true
      this.msg = false
      this.channel = ''
      this.country = ''
      this.language = ''
      this.valid_ = 1
      this.platform = 0
      this.ver = 0
      this.thanVer = 0
      this.lessVer = 0
      this.isNew = 0
      this.isPay = 0
      this.bossLevel = -1
      this.agentId = -1
      this.hostLevel = -1
      this.configKey = this.row.configKey
      this.defaultVal = ''
    },
    // 修改
    modify(row) {
      this.msg = true
      this.channel = row.channel
      this.country = row.countryCode
      this.configKey = row.configKey
      this.platform = row.platform
      this.language = row.langId
      this.isPay = row.isPay
      this.isNew = row.isNew
      this.ver = row.ver
      this.thanVer = row.thanVer
      this.valid_ = row.valid
      this.lessVer = row.lessVer
      this.majia = row.majia
      try {
        if (typeof row.configValue === 'object') {
          this.defaultVal = row.configValue;
          this.tempVal = JSON.parse(JSON.stringify(row.configValue));
        } else {
          this.defaultVal = JSON.parse(row.configValue);
          this.tempVal = JSON.parse(row.configValue);
        }
      } catch (error) {
        this.defaultVal = row.configValue;
        this.tempVal = row.configValue;
      }
      this.id = row.id
      this.hostLevel = row.hostLevel
      this.bossLevel = row.bossLevel
      this.agentId = row.agentId
      this.drawer = true
    },
    // 处理表单提交
    handleSubmit(data) {
      this.defaultVal = data;
      this.dialogVisible = false;
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    },
    handleClose() {
      this.channel = ''
      this.country = ''
      this.receivedDesc = ''
      this.matchCardRules = ''
      this.canReceiveNumsOnce = 0
      this.canReceiveTimesPerDay = 0
      this.canReceiveTotalDays = 0
      this.receiveWaitingTimeMin = 0
      this.valid_ = 1
      this.drawer = false
    },
    async _valid(row) {
      let num = 0
      if (row.valid == 0) {
        num = 1
      } else {
        num = 0
      }
      let url =
        this.$store.getters.path.config_key_updateValid +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        id: row.id,
        valid: num,
        operator: this.operator,
      }
      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.getDayChatDetai()
    },
    // 处理查看按钮点击
    handleView() {
      try {
        // 如果已经是对象，直接使用
        if (typeof this.defaultVal === 'object') {
          this.tempVal = JSON.parse(JSON.stringify(this.defaultVal));
        } else {
          // 如果是字符串，尝试解析
          this.tempVal = JSON.parse(this.defaultVal);
        }
        this.dialogVisible = true;
      } catch (error) {
        this.$message.error('JSON 格式错误');
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}

.add {
  padding: 0 0 50px;

  .ruid {
    >div {
      margin: 0 0 20px;

      > :nth-child(1) {
        margin: 0 0 20px;
      }

      .text {
        display: flex;
        align-items: center;
      }

      span {
        width: 120px;
        display: inline-block;
        margin: 0 30px 10px;
      }
    }
  }

  .buttom {
    display: flex;
    justify-content: flex-end;
    margin: 0 100px;
  }
}

.va {
  color: #1dad21;
  cursor: pointer;
}

.jsoneditor-vue {
  width: 320px;
}
</style>
